import { FeeTiers, LevelTiers } from "../../Models/Tiers";
import { baseUrl, extendHeaders } from "./HelpService";


const PageUrl = baseUrl + 'tiers/';


const getLeveTiers = (): Promise<Response | null> => {
    return fetch(PageUrl + 'getLeveTiers/', {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};

const getFeeTiers = (): Promise<Response | null> => {
    return fetch(PageUrl + 'getFeeTiers/', {
        method: "GET",
        headers: extendHeaders(),
    })
        .then((response: any) => response.json())
        .then((data: any) => data as Response)
        .catch((error) => {
            return null;
        });
};


const updateFeeTiersRow = (fee_tiers: FeeTiers): Promise<Response | null> => {
    return fetch(PageUrl + "updateFeeTiers/", {
        method: "PUT",
        headers: extendHeaders(),
        body: JSON.stringify(fee_tiers)
    })
        .then((response) => response.json())
        .then((data) => data as Response)
        .catch(error => {
            return null;
        });
};

const updateLevelTiersTable = (level_tiers: LevelTiers): Promise<Response | null> => {
    return fetch(PageUrl + "updateLevelTiers/", {
        method: "PUT",
        headers: extendHeaders(),
        body: JSON.stringify(level_tiers)
    })
        .then((response) => response.json())
        .then((data) => data as Response)
        .catch(error => {
            return null;
        });
};


const TiersService = {
    getLeveTiers,
    getFeeTiers,
    updateFeeTiersRow,
    updateLevelTiersTable
};

export default TiersService;
